export default class RichTextStyling { };

RichTextStyling.fromFontPropertiesOnTextObject = function (textObject) {
    const fontSize = parseInt(textObject.font.split("px")[0]);
    const fontFamily = textObject.font.split("px")[1].trim().replace(/'/g, "").replace(/"/g, "").trim();

    return {
        b: { font: "bold " + fontSize + "px '" + fontFamily + "'" },
        i: { font: "italic " + fontSize + "px '" + fontFamily + "'" },
        bi: { font: "bold italic " + fontSize + "px '" + fontFamily + "'" },
        a: {
            font: fontSize + "px '" + fontFamily + "'",
            hover: {
                color: "#1F40E6"
            }
        },
        _default: {
            font: fontSize + "px '" + fontFamily + "'"
        }
    };
}